import styled from "styled-components";
import { palette } from "styled-theme";
import bgImage from "../../../image/CreateAccount_Login.jpg";
import forgetPassBg from '../../../image/ChangePassword_RecoverPassword.jpg'
import WithDirection from "../../../settings/withDirection";

const LoginStyleWrapper = styled.div`
  width: 100%;
  min-height: 100vh;
  height: 100vh;
  display: flex;
  align-items: center;
  position: relative;

  &:before {
    content: "";
    width: 100%;
    height: 100%;
    display: flex;
    background-color: rgba(0, 0, 0, 0.6);
    position: absolute;
    z-index: 1;
    top: 0;
    left: ${props => (props["data-rtl"] === "rtl" ? "inherit" : "0")};
    right: ${props => (props["data-rtl"] === "rtl" ? "0" : "inherit")};
  }

  .login-image {
    width: 100%;
    min-height: 100vh;
    height: 100vh;
    background: url(${bgImage}) no-repeat center center;
    background-size: cover;
    background-color: #f7f7ff;
    z-index: 1;
  }
  
  .login-image.change-password{
    background-image: url(${forgetPassBg});
  }
  
  .isoLoginContentWrapper {
    width: 1000px;
    height: 100%;
    overflow-y: auto;
    z-index: 10;
    position: relative;
    background-color: #ffffff;
    display: flex;
    justify-content: center;
  }

  .isoLoginContent {
    width: 375px;
    min-height: 100%;
    display: flex;
    flex-direction: column;
    position: relative;
    background-color: #ffffff;
    justify-content: center;
    @media only screen and (max-width: 768px) {
      width: 100%;
      padding: 70px 30px;
    }
    @media only screen and (max-width: 450px) {
      justify-content: start;
    }
    .isoLogoWrapper {
      width: 100%;
      display: flex;
      margin-bottom: 15px;
      flex-shrink: 0;
      font-size: 24px;
      font-weight: 700;
      line-height: 1;
      color: ${palette("text", 1)};
    }
    .loginCreateAccount {
      margin-bottom: 50px;
      a {
        color: ${palette("primary", 1)};
        font-weight: 400;
        text-decoration: underline;
      }
    }
    .isoLoginForm {
      width: 100%;
      display: flex;
      flex-shrink: 0;
      flex-direction: column;

      .isoInputWrapper {
        height: 64px;
        &:last-of-type {
          margin-bottom: 0;
        }
      }

      .isoHelperText {
        font-size: 12px;
        font-weight: 400;
        line-height: 1.2;
        color: ${palette("grayscale", 1)};
        padding-left: ${props =>
          props["data-rtl"] === "rtl" ? "inherit" : "13px"};
        padding-right: ${props =>
          props["data-rtl"] === "rtl" ? "13px" : "inherit"};
        margin: 15px 0;
        position: relative;
        display: flex;
        align-items: center;

        &:before {
          content: "*";
          color: ${palette("error", 0)};
          padding-right: 3px;
          font-size: 14px;
          line-height: 1;
          position: absolute;
          top: 2px;
          left: ${props => (props["data-rtl"] === "rtl" ? "inherit" : "0")};
          right: ${props => (props["data-rtl"] === "rtl" ? "0" : "inherit")};
        }
      }
      .isoForgotPass {
        font-size: 16px;
        color: ${palette("primary", 1)};
        margin-bottom: 25px;
        text-decoration: none;
        width: 100%;
        text-align: right;
        span {
          display: block;
          line-height: 12px;
        }
        &:hover {
          color: ${palette("primary", 0)};
        }
      }
      .isoLoginBtn {
        margin-top: 10px;
        > a {
          display: flex;
          margin-bottom: 10px;

          &:last-child {
            margin-bottom: 0;
          }
        }

        button {
          width: 100%;
          font-weight: 400;
        }

        .or {
          padding-bottom: 10px;
          border-bottom: 1px solid #ccc;
          text-align: center;
          margin-top: 25px;
          margin-bottom: 30px;
          font-size: 16px;
        }
      }
    }
  }
`;

export default WithDirection(LoginStyleWrapper);
